import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromFeatureFlagsActions from '../+state/actions/feature-flags.actions';

@Injectable({ providedIn: 'root' })
export class FeatureFlagsFacade {
  constructor(private store: Store) {}

  storeFeatureFlagsValues() {
    this.store.dispatch(fromFeatureFlagsActions.StoreFeatureFlagsValues());
  }
}
